const styles = {
    menuItem: {
        fontSize: 14
    },
    innerDiveStyle:{
        height: 20
    },
    selectedItem: {
        backgroundColor: '#02ABCA',
        color: 'white'
    }
  };

  export default styles;


// WEBPACK FOOTER //
// ./src/components/accountSelector/styles/AccountSelectorStyles.js